<template>
  <div class="chapter chapter--experts">

    <section class="section__experts section__experts--01">
      <div class="bg-highlight pt-8 pb-3 pb-lg-0 pt-lg-0">
        <div class="container py-lg-5">
          <div class="row">
            <div class="col-12 col-lg-10">
              <h1 class="color-white font-size-56 font-bold text-uppercase mb-2" data-aos="fade-up" data-aos-delay="600"
                  v-html="$t('PAGE03_TEXT01')"></h1>
              <h2 class="color-white font-size-30 font-bold" data-aos="fade-up" data-aos-delay="600"
                  v-html="$t('PAGE03_TEXT02')"></h2>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section__experts section__experts--02">
      <div class="container pl-lg-10 pl-xl-0 pt-4 pt-lg-15">
        <div class="row padding__row">
          <div class="col-10 offset-1 col-lg-10 offset-lg-1 text-center">
            <p class="d-lg-none d-block" data-aos="fade-down" data-aos-delay="300" v-html="$t('PAGE03_TEXT03')"></p>
            <p class="d-none d-lg-block" data-aos="fade-down" data-aos-delay="300" v-html="$t('PAGE03_TEXT04')"></p>
            <p class="font-bold d-lg-none" data-aos="fade-down" data-aos-delay="300" v-html="$t('PAGE03_TEXT05')"></p>
            <p class="d-lg-block d-none font-bold" data-aos="fade-down" data-aos-delay="300" v-html="$t('PAGE03_TEXT06')"></p>
          </div>
        </div>
        <div class="row my-4 my-lg-8 padding__row">
          <div class="col-12 text-center">
            <button type="button" class="btn mr-0 mb-3 mb-lg-0 mr-lg-5" :class="[chapterActive === 1 ? 'active' : '']"
                    v-on:click="changeChapter(1)" v-html="$t('PAGE03_TEXT07')">
            </button>
            <button type="button" class="btn mb-0" :class="[chapterActive === 2 ? 'active' : '']"
                    v-on:click="changeChapter(2)" v-html="$t('PAGE03_TEXT08')">
            </button>
          </div>
        </div>
        <div class="row padding__row-img">
          <template>
            <div class="col-12 text-center d-flex justify-content-center">
              <div class="changes__info position-relative ">
                <img src="@/assets/images/03/s02_p01.png" class="img-fluid" v-if="window.width >= 768">
                <img src="@/assets/images/03/s02_p01-mobile.png" class="img-fluid" v-else>
                <div v-if="chapterActive == 1">
                  <div class="point__wrapper point__wrapper-01" :class="{'active': pointIndex == 1}">
                    <div class="point__text" >
                      <div class="mobile__close" v-on:click="pointIndex = 0">
                        <img src="@/assets/icons/white/close.svg" class="img-fluid">
                      </div>
                      <p v-html="$t('PAGE03_TEXT09')"></p>
                    </div>
                    <div class="point__indicator" v-on:click="openPoint(1)"></div>
                  </div>
                  <div class="point__wrapper point__wrapper-02" :class="{'active': pointIndex == 2}">
                    <div class="point__text" >
                      <div class="mobile__close" v-on:click="pointIndex = 0">
                        <img src="@/assets/icons/white/close.svg" class="img-fluid">
                      </div>
                      <p v-html="$t('PAGE03_TEXT10')"></p>
                    </div>
                    <div class="point__indicator" v-on:click="openPoint(2)"></div>
                  </div>
                  <div class="point__wrapper point__wrapper-03" :class="{'active': pointIndex == 3}">
                    <div class="point__text" >
                      <div class="mobile__close" v-on:click="pointIndex = 0">
                        <img src="@/assets/icons/white/close.svg" class="img-fluid">
                      </div>
                      <p v-html="$t('PAGE03_TEXT11')"></p>
                    </div>
                    <div class="point__indicator" v-on:click="openPoint(3)"></div>
                  </div>
                </div>
                <div v-if="chapterActive == 2">
                  <div class="point__wrapper point__wrapper-04" :class="{'active': pointIndex == 4}">
                    <div class="point__text" >
                      <div class="mobile__close" v-on:click="pointIndex = 0">
                        <img src="@/assets/icons/white/close.svg" class="img-fluid">
                      </div>
                      <p v-html="$t('PAGE03_TEXT12')"></p>
                    </div>
                    <div class="point__indicator" v-on:click="openPoint(4)"></div>
                  </div>
                  <div class="point__wrapper point__wrapper-05" :class="{'active': pointIndex == 5}">
                    <div class="point__text" >
                      <div class="mobile__close" v-on:click="pointIndex = 0">
                        <img src="@/assets/icons/white/close.svg" class="img-fluid">
                      </div>
                      <p v-html="$t('PAGE03_TEXT13')"></p>
                    </div>
                    <div class="point__indicator" v-on:click="openPoint(5)"></div>
                  </div>
                  <div class="point__wrapper point__wrapper-06" :class="{'active': pointIndex == 6}">
                    <div class="point__text" >
                      <div class="mobile__close" v-on:click="pointIndex = 0">
                        <img src="@/assets/icons/white/close.svg" class="img-fluid">
                      </div>
                      <p v-html="$t('PAGE03_TEXT14')"></p>
                    </div>
                    <div class="point__indicator" v-on:click="openPoint(6)"></div>
                  </div>
                </div>
              </div>
            </div>
          </template>


        </div>
        <div class="row padding__row-img ">
          <div class="col-12 text-center bg-beige px-4 py-8 ">
            <p class="mb-0" v-html="$t('PAGE03_TEXT15')"></p>
          </div>
        </div>
      </div>
    </section>

    <section class="section__experts section__experts--03 pt-0 pt-lg-4 pt-lg-15">
      <div class="bg-highlight  py-5 py-lg-0">
        <div class="container py-lg-5">
          <div class="row">
            <div class="col-12 col-lg-10">
              <h1 class="color-white font-size-56 font-bold text-uppercase mb-2" data-aos="fade-up" data-aos-delay="600"
                  v-html="$t('PAGE03_TEXT16')"></h1>
              <h2 class="color-white font-size-30 font-bold" data-aos="fade-up" data-aos-delay="600"
                  v-html="$t('PAGE03_TEXT17')"></h2>
            </div>
          </div>
        </div>
      </div>

    </section>
    <section class="section__experts section__experts--04 py-0">
      <div class="container-fluid pl-lg-10 pl-xl-0 position-relative">
        <div class="row">
          <div class="col-12 col-xl-11 offset-xl-1">
            <div class="d-block position-absolute click__info">
              <p class="font-bold font-size-30" data-aos="zoom-in"
                 data-aos-delay="500" v-html="$t('PAGE03_TEXT25')"></p>
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col-12 col-xl-4 offset-xl-1 mt-20 mt-lg-20 pb-5">
            <div class="row mb-4">
              <template v-if="window.width > 768">
                <div class="col-3 product__01">
                  <img src="@/assets/images/03/s03_p01.png" class="img-fluid mb-4" data-aos="fade-right" data-aos-delay="500" v-on:click="openOverlay(1)">
                </div>
                <div class="col-9 d-flex align-items-start flex-column">
                  <p class="" v-html="$t('PAGE03_TARGET_01')"></p>
                  <h3 class="font-bold" data-aos="fade-down" data-aos-delay="500" v-html="$t('PAGE03_TEXT18')" v-on:click="openOverlay(1)"></h3>
<!--                  <p data-aos="fade-down" data-aos-delay="600" v-html="$t('PAGE03_TEXT19')"></p>-->
                  <p data-aos="fade-down" data-aos-delay="600" v-html="$t('PAGE03_TEXT20')"></p>
<!--                  <div class="retinol__info" v-on:click="openOverlay(4)">
                    <img src="@/assets/icons/play_button.svg" data-aos="fade-down" data-aos-delay="600" class="icon__content" v-on:click="play()">
                    <p data-aos="fade-down" data-aos-delay="600" v-html="$t('PAGE03_TEXT20-01')"></p>
                  </div>-->
                </div>
              </template>
              <template v-else>
                <div class="col-12 d-flex align-items-start flex-column">
                  <p class="" v-html="$t('PAGE03_TARGET_01')"></p>
                  <h3 class="font-bold" data-aos="fade-down" data-aos-delay="500" v-html="$t('PAGE03_TEXT18')" v-on:click="openOverlay(1)"></h3>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-4">
                      <img src="@/assets/images/03/s03_p01.png" class="img-fluid mb-4" data-aos="fade-right" data-aos-delay="500" v-on:click="openOverlay(1)">
                    </div>
                    <div class="col-8 d-flex flex-column justify-content-center">
<!--                      <p data-aos="fade-down" data-aos-delay="600" v-html="$t('PAGE03_TEXT19')"></p>-->
                      <p data-aos="fade-down" data-aos-delay="600" v-html="$t('PAGE03_TEXT20')"></p>
<!--                      <div class="retinol__info" v-on:click="openOverlay(4)">
                        <img src="@/assets/icons/play_button.svg" data-aos="fade-down" data-aos-delay="600" class="icon__content" v-on:click="play()">
                        <p data-aos="fade-down" data-aos-delay="600" v-html="$t('PAGE03_TEXT20-01')"></p>
                      </div>-->
                    </div>
                  </div>


                </div>
              </template>

            </div>
            <div class="row mb-4">
              <template v-if="window.width > 768">
                <div class="col-8 offset-4 offset-lg-0 col-lg-6 product__01">
                  <img src="@/assets/images/03/s03_p02.png" class="img-fluid mb-4" data-aos="fade-right" data-aos-delay="500" v-on:click="openOverlay(3)">
                </div>
                <div class="col-12 col-lg-6 d-flex align-items-start flex-column">
                  <p class="" v-html="$t('PAGE03_TARGET_02')"></p>
                  <h3 class="font-bold" data-aos="fade-down" data-aos-delay="500" v-html="$t('PAGE03_TEXT21')" v-on:click="openOverlay(3)"></h3>
                  <p data-aos="fade-down" data-aos-delay="600" v-html="$t('PAGE03_TEXT22')"></p>
                  <p data-aos="fade-down" data-aos-delay="600" v-html="$t('GLOBAL_NOT_AVAILABLE_TR_02')" v-if="user.user.country == 'TX'"></p>
                </div>
              </template>
              <template v-else>
                <div class="col-12 col-lg-6 d-flex align-items-start flex-column">
                  <p class="" v-html="$t('PAGE03_TARGET_02')"></p>
                  <h3 class="font-bold" data-aos="fade-down" data-aos-delay="500" v-html="$t('PAGE03_TEXT21')" v-on:click="openOverlay(3)"></h3>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-6">
                      <img src="@/assets/images/03/s03_p02.png" class="img-fluid mb-4" data-aos="fade-right" data-aos-delay="500" v-on:click="openOverlay(3)">
                    </div>
                    <div class="col-6 d-flex flex-column justify-content-center">

                      <p data-aos="fade-down" data-aos-delay="600" v-html="$t('PAGE03_TEXT22')"></p>
                      <p data-aos="fade-down" data-aos-delay="600" v-html="$t('GLOBAL_NOT_AVAILABLE_TR_02')" v-if="user.user.country == 'TX' "></p>
                    </div>
                  </div>
                </div>
              </template>

            </div>
            <div class="row mb-2 mb-lg-4">
              <template v-if="window.width > 768">
                <div class="col-3 product__01">
                  <img src="@/assets/images/03/s03_p03.png" class="img-fluid mb-4" data-aos="fade-right" data-aos-delay="500" v-on:click="openOverlay(2)">
                </div>
                <div class="col-9 d-flex align-items-start flex-column">
                  <p class="" v-html="$t('PAGE03_TARGET_03')"></p>
                  <h3 class="font-bold" data-aos="fade-down" data-aos-delay="500" v-html="$t('PAGE03_TEXT23')" v-on:click="openOverlay(2)"></h3>
                  <p data-aos="fade-down" data-aos-delay="600" v-html="$t('PAGE03_TEXT24')"></p>
                  <p data-aos="fade-down" data-aos-delay="600" v-html="$t('GLOBAL_NOT_AVAILABLE_TR_02')" v-if="user.user.country == 'TX'"></p>
                </div>
              </template>
              <template v-else>
                <div class="col-12 d-flex align-items-start flex-column">
                  <p class="" v-html="$t('PAGE03_TARGET_03')"></p>
                  <h3 class="font-bold" data-aos="fade-down" data-aos-delay="500" v-html="$t('PAGE03_TEXT23')" v-on:click="openOverlay(2)"></h3>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-4">
                      <img src="@/assets/images/03/s03_p03.png" class="img-fluid mb-4" data-aos="fade-right" data-aos-delay="500" v-on:click="openOverlay(2)">
                    </div>
                    <div class="col-8 d-flex flex-column justify-content-center">
                      <p data-aos="fade-down" data-aos-delay="600" v-html="$t('PAGE03_TEXT24')"></p>
                      <p data-aos="fade-down" data-aos-delay="600" v-html="$t('GLOBAL_NOT_AVAILABLE_TR_02')" v-if="user.user.country == 'TX' "></p>
                    </div>
                  </div>
                </div>
              </template>

            </div>

          </div>
          <div class="col-12 d-block d-lg-none">
            <img src="@/assets/images/03/s03_bg-no-space.png" class="img-fluid">
          </div>
          <div class="col-12 col-xl-7 concern__bg" :style="{backgroundImage: 'url('+require('@/assets/images/03/s03_bg-no-space.png')+')'}">

          </div>
        </div>

      </div>
    </section>
    <div class="overlay overlay__01" ref="overlay-1" :class="{'active' : overlaysStatus[0] == 1}">
      <div class="overlay__headline">
        <div class="overlay__close" v-on:click="closeOverlay">
          <img src="@/assets/icons/white/close.svg" class="img-fluid">
        </div>
        <div class="bg-highlight">
          <div class="container py-lg-5">
            <div class="row">
              <div class="col-12 col-lg-10">
                <h3 class="color-white font-size-36 font-bold text-uppercase" v-html="$t('PAGE03_OVERLAY01_TEXT01')"></h3>
                <h2 class="color-white font-size-56 font-bold text-uppercase" v-html="$t('PAGE03_OVERLAY01_TEXT02')"></h2>
                <h3 class="color-white font-size-30 font-bold text-uppercase" v-html="$t('PAGE03_OVERLAY01_TEXT03-01')"></h3>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay__content">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <slick ref="overlay_slider-01" class="pb-0" :options="slickOptions" @beforeChange="handleBeforeChange">
                <!-- desktop -->
                <template v-if="window.width > 768">
                  <div class="slide py-6">
                    <div class="row">
                      <div class="col-12 col-lg-3 d-flex ">
                        <div class="row">
                          <div class="col-3 offset-2 offset-lg-0 col-lg-6 d-flex align-items-center justify-content-center">
                            <img src="@/assets/images/03/s03_p01-big.png" class="img-fluid">
                          </div>
                          <div class="col-6 col-lg-6 d-flex align-items-end justify-content-center">
                            <img src="@/assets/images/03/s03_p04.png" class="img-fluid">
                          </div>
                        </div>


                      </div>
                      <div class="col-lg-4 col-10 offset-1 offset-lg-0 d-flex align-items-center justify-content-center">
                        <div class="img--bordered">
                          <img src="@/assets/images/03/s03_p05.jpg" class="img-fluid">
                        </div>

                      </div>
                      <div class="col-lg-5 col-10 offset-1 offset-lg-0 d-flex align-items-center justify-content-center">
                        <div class="img--bordered">
                          <img src="@/assets/images/03/s03_p06.jpg" class="img-fluid">
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- mobile -->
                <template v-else>
                  <div class="slide">
                    <div class="row py-5 ">
                      <div class="col-4 offset-2">
                        <img src="@/assets/images/03/s03_p01-big.png" class="img-fluid">
                      </div>
                      <div class="col-4 d-flex align-items-center">
                        <img src="@/assets/images/03/s03_p04.png" class="img-fluid">
                      </div>
                    </div>

                  </div>
                  <div class="slide">
                    <div class="row py-5 ">
                      <div class="col-10 offset-1">
                        <div class="img--bordered">
                          <img src="@/assets/images/03/s03_p05.jpg" class="img-fluid">
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="slide">
                    <div class="row py-5 " >
                      <div class="col-10 offset-1">
                        <div class="img--bordered">
                          <img src="@/assets/images/03/s03_p06.jpg" class="img-fluid">
                        </div>
                      </div>
                    </div>

                  </div>
                </template>

              </slick>
            </div>

          </div>
          <div class="row my-6">
            <div class="col-12">
              <div class="d-flex align-items-center justify-content-center">
                <button class="btn" v-html="$t('GLOBAL_DETAILS')" v-on:click="goToDetail(1)"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay overlay__04" ref="overlay-1" :class="{'active' : overlaysStatus[3] == 1}">
      <div class="overlay__headline">
        <div class="overlay__close" v-on:click="closeOverlay">
          <img src="@/assets/icons/white/close.svg" class="img-fluid">
        </div>
        <div class="bg-highlight">
          <div class="container py-lg-5">
            <div class="row">
              <div class="col-12 col-lg-10">
                  <h2 class="color-white font-size-56 font-bold text-uppercase" v-html="$t('PAGE03_OVERLAY01_TEXT03-02')"></h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay__content">
        <div class="container">
          <div class="row">
            <div class="col-12 d-flex justify-content-center">
                <div class="slide py-6">
                  <div class="row">
                    <div class="col-12 d-flex flex-column justify-content-center">
                      <p class="text-center" v-html="$t('PAGE03_OVERLAY01_TEXT06')"></p>
                      <p class="text-center" v-html="$t('PAGE03_OVERLAY01_TEXT07')"></p>
                      <div class="row">
                        <div class="col-12 d-flex align-items-center ">
                          <div class="video--container embed-responsive embed-responsive-16by9 ">
                            <video src="@/assets/videos/s03_retinol.mp4" class="embed-responsive-item" ref="video" @ended="videoEnded()" controls></video>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>

                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay overlay__02" ref="overlay-2" :class="{'active' : overlaysStatus[1] == 1}">
      <div class="overlay__headline">
        <div class="overlay__close" v-on:click="closeOverlay">
          <img src="@/assets/icons/white/close.svg" class="img-fluid">
        </div>
        <div class="bg-highlight">
          <div class="container py-lg-5">
            <div class="row">
              <div class="col-12 col-lg-10">
                <h3 class="color-white font-size-36 font-bold text-uppercase" v-html="$t('PAGE03_OVERLAY02_TEXT01')"></h3>
                <h2 class="color-white font-size-56 font-bold text-uppercase" v-html="$t('PAGE03_OVERLAY02_TEXT02')"></h2>
                <h3 class="color-white font-size-30 font-bold text-uppercase" v-html="$t('PAGE03_OVERLAY02_TEXT03')"></h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay__content">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <template v-if="window.width > 768">
                <div class="row pt-6">
                  <div class="col-10 offset-1 offset-lg-0 col-lg-3 d-flex ">
                    <div class="row">
                      <div class="col-4 offset-2 offset-lg-0 col-lg-6 d-flex align-items-center justify-content-center">
                        <img src="@/assets/images/03/s03_p03-big.png" class="img-fluid">
                      </div>
                      <div class="col-6 d-flex align-items-end justify-content-center">
                        <img src="@/assets/images/03/s03_p10.png" class="img-fluid">
                      </div>
                    </div>


                  </div>
                  <div class="col-10 offset-1 offset-lg-0 col-lg-4 d-flex align-items-center justify-content-center">
                    <div class="img--bordered">
                      <img src="@/assets/images/03/s03_p08.jpg" class="img-fluid">
                    </div>

                  </div>
                  <div class="col-10 offset-1 offset-lg-0 col-lg-5  d-flex align-items-center justify-content-center">
                    <div class="img--bordered">
                      <img src="@/assets/images/03/s03_p09.jpg" class="img-fluid">
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="pt-5">
                  <slick ref="overlay_slider-02" class="pb-0" :options="slickOptions">
                    <div>
                      <div class="row">
                        <div class="col-4 offset-1 offset-lg-0 col-lg-6 d-flex align-items-center justify-content-center">
                          <img src="@/assets/images/03/s03_p03-big.png" class="img-fluid">
                        </div>
                        <div class="col-6 d-flex align-items-end justify-content-center">
                          <img src="@/assets/images/03/s03_p10.png" class="img-fluid">
                        </div>
                      </div>
                    </div>

                    <div class="col-10 offset-1">
                      <div class="img--bordered">
                        <img src="@/assets/images/03/s03_p08.jpg" class="img-fluid">
                      </div>

                    </div>
                    <div class="col-10 offset-1 ">
                      <div class="img--bordered">
                        <img src="@/assets/images/03/s03_p09.jpg" class="img-fluid">
                      </div>
                    </div>


                  </slick>
                </div>
              </template>
              <div class="row my-6">
                <div class="col-12">
                  <div class="d-flex align-items-center justify-content-center">
                    <button class="btn" v-html="$t('GLOBAL_DETAILS')" v-on:click="goToDetail(2)"></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay overlay__03" ref="overlay-3" :class="{'active' : overlaysStatus[2] == 1}">
      <div class="overlay__headline">
        <div class="overlay__close" v-on:click="closeOverlay">
          <img src="@/assets/icons/white/close.svg" class="img-fluid">
        </div>
        <div class="bg-highlight">
          <div class="container py-lg-5">
            <div class="row">
              <div class="col-12 col-lg-10">
                <h3 class="color-white font-size-36 font-bold text-uppercase" v-html="$t('PAGE03_OVERLAY03_TEXT01')"></h3>
                <h2 class="color-white font-size-56 font-bold text-uppercase" v-html="$t('PAGE03_OVERLAY03_TEXT02')"></h2>
                <h3 class="color-white font-size-30 font-bold text-uppercase" v-html="$t('PAGE03_OVERLAY03_TEXT03')"></h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay__content">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <template v-if="window.width > 768">
                <div class="row pt-6">
                  <div class="col-10 offset-1 offset-lg-0 col-lg-6 mb-5 mb-lg-0">
                    <img src="@/assets/images/03/s03_p02-big.png" class="img-fluid px-10">
                  </div>
                  <div class="col-10 offset-1 offset-lg-0 col-lg-6 d-flex align-items-center ">
                    <div class="img--bordered w-100">
                      <div class="video--container embed-responsive embed-responsive-16by9 ">
                        <video src="@/assets/videos/s03_mask.mp4" class="embed-responsive-item" poster="@/assets/images/03/s03_poster.jpg" ref="video" @ended="videoEnded()" autoplay muted loop></video>
                      </div>
                    </div>

                  </div>
                </div>
              </template>
              <template v-else>
                <div class="pt-6">
                  <Slick :options="slickOptions" ref="overlay_slider-03">
                    <div class="col-10 offset-1 offset-lg-0">
                      <img src="@/assets/images/03/s03_p02-big.png" class="img-fluid">
                    </div>
                    <div class="col-10 offset-1 offset-lg-0 d-flex align-items-center img--bordered">
                      <div class="video--container embed-responsive embed-responsive-16by9 ">
                        <video src="@/assets/videos/s03_mask.mp4" class="embed-responsive-item" poster="@/assets/images/03/s03_poster.jpg" ref="video" @ended="videoEnded()" autoplay muted loop></video>
                      </div>
                    </div>
                  </Slick>
                </div>

              </template>

              <div class="row my-6 mt-12">
                <div class="col-12">
                  <div class="d-flex align-items-center justify-content-center">
                    <button class="btn" v-html="$t('GLOBAL_DETAILS')" v-on:click="goToDetail(3)"></button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <Footer :lang-key="'GLOBAL_FOOTER03'" :kapitel="'04'" />

  </div>
</template>

<script>
import lrsService from "@/services/lrsService";
import Footer from "@/components/partials/Footer";
import jQuery from 'jquery'
import Slick from 'vue-slick';
export default {
  name: "page-030",
  components: {
    Footer, Slick
  },
  props: {
    kapitel: ""
  },
  data: function () {
    return {
      lang: '',
      country: '',
      videoActive: 0,
      chapterActive: 1,
      buttonActive: 0,
      user: Object,
      tracking: [0,0,0,0,0,0],
      detailTracking: [0,0,0],
      chapterTracking: [1,0],
      moduleStatus: '',
      productMask:
          'https://www.discover-shiseido.com/shiseido-skincare_dv_en/vital-perfection/uplifting-and-firming-express-eye-mask/?module=VitalPerfection-AW-2020&chapter=pages/03&mpage=page-010&position=2&lang=dv_en',
      productCream:
          'https://www.discover-shiseido.com/shiseido-skincare_dv_en/vital-perfection/uplifting-and-firming-eye-cream/?module=VitalPerfection-AW-2020&chapter=pages/03&mpage=page-010&position=1&lang=dv_en',
      slickOptions: {
        slidesToShow: 1,
        arrows: true,
        prevArrow: '<div class="slick__arrow slick__prev"></div>',
        nextArrow: '<div class="slick__arrow slick__next"></div>',
        dots: false,
        infinite: false,
        adaptiveHeight: true
      },
      overlaySlideIndex: 0,
      isPlaying: false,
      overlaysStatus: [0,0,0,0],
      pointIndex: 0,
      trackingPercentage: 0,
      window: {
        width: 0,
        height: 0
      }

    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.$store.watch(
        (state, getters) => getters.user,
        (newValue, oldValue) => {
          if (typeof newValue === 'string' || newValue instanceof String) {
            this.user = JSON.parse(newValue)
          }
          this.user = newValue;
        },
    );
    this.$store.watch(
        (state, getters) => getters.moduleStatus,
        (newValue, oldValue) => {

          this.moduleStatus = newValue;
          for (let i = 0; i < this.moduleStatus.length; i++) {
            if(this.moduleStatus[i][0]  == '03'){
              this.tracking = [1,1,1,1,1];
              this.detailTracking = [1,1,1];
            }
          }
        },
    );
    /*this.$store.watch(
            (state, getters) => getters.lang,
            (newValue, oldValue) => {
              console.log(`Updating lang from ${oldValue} to ${newValue}`);
              this.lang = newValue;
              this.productMask = "https://www.discover-shiseido.com/shiseido-skincare_dv_en/vital-perfection/uplifting-and-firming-express-eye-mask/?module=VitalPerfection-AW-2020&chapter=pages/03&mpage=page-010&position=2&lang="+this.country+"_"+this.lang+'"';
              this.productMask = "https://www.discover-shiseido.com/shiseido-skincare_dv_en/vital-perfection/uplifting-and-firming-eye-cream/?module=VitalPerfection-AW-2020&chapter=pages/03&mpage=page-010&position=1&lang="+this.country+"_"+this.lang+'"';

              },
    );
    this.$store.watch(
            (state, getters) => getters.country,
            (newValue, oldValue) => {
              console.log(`Updating lang from ${oldValue} to ${newValue}`);
              this.country = newValue;
              this.productMask = "https://www.discover-shiseido.com/shiseido-skincare_dv_en/vital-perfection/uplifting-and-firming-express-eye-mask/?module=VitalPerfection-AW-2020&chapter=pages/03&mpage=page-010&position=2&lang="+this.country+"_"+this.lang+'"';
              this.productMask = "https://www.discover-shiseido.com/shiseido-skincare_dv_en/vital-perfection/uplifting-and-firming-eye-cream/?module=VitalPerfection-AW-2020&chapter=pages/03&mpage=page-010&position=1&lang="+this.country+"_"+this.lang+'"';
            },
    );*/
  },
  methods: {
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      console.log(nextSlide, currentSlide);
      this.overlaySlideIndex = nextSlide;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    play(){
      this.$refs.video.play();
      this.isPlaying = true;
    },
    pause(){
      this.$refs.video.pause();
      this.isPlaying = false;
    },
    openOverlay(id){
      /*console.log(id);
      this.overlaysStatus = [0,0,0,0];
      this.overlaysStatus[id-1] = 1;
      document.body.classList.add('overflow--hidden');
      if(this.$refs["overlay_slider-0"+id]){
        this.$refs["overlay_slider-0"+id].reSlick();
      }*/

      let url;
      let lang = this.$store.getters.lang;
      let country = this.$store.getters.country;
      if (id == 1){
        url = 'https://www.discover-shiseido.com/shiseido-skincare_'+country+'_'+lang+'/vital-perfection/intensive-wrinklespot-treatment/?module=VitalPerfectionLiftDefine&chapter=pages/03&mpage=010&position=1';
      } else if(id == 2){
        url = 'https://www.discover-shiseido.com/shiseido-skincare_'+country+'_'+lang+'/vital-perfection/liftdefine-radiance-serum/?module=VitalPerfectionLiftDefine&chapter=pages/03&mpage=010&position=2';
      } else if(id == 3){
        url = 'https://www.discover-shiseido.com/shiseido-skincare_'+country+'_'+lang+'/vital-perfection/liftdefine-radiance-face-mask/?module=VitalPerfectionLiftDefine&chapter=pages/03&mpage=010&position=3';

      }
      location.href = url;
      console.log(url)
    },
    goToDetail(id){
      let url;
      let lang = this.$store.getters.lang;
      let country = this.$store.getters.country;
      if (id == 1){
        url = 'https://www.discover-shiseido.com/shiseido-skincare_'+country+'_'+lang+'/vital-perfection/intensive-wrinklespot-treatment/?module=VitalPerfectionLiftDefine&chapter=pages/03&mpage=010&position=1';
      } else if(id == 2){
        url = 'https://www.discover-shiseido.com/shiseido-skincare_'+country+'_'+lang+'/vital-perfection/liftdefine-radiance-serum/?module=VitalPerfectionLiftDefine&chapter=pages/03&mpage=010&position=2';
      } else if(id == 3){
        url = 'https://www.discover-shiseido.com/shiseido-skincare_'+country+'_'+lang+'/vital-perfection/liftdefine-radiance-face-mask/?module=VitalPerfectionLiftDefine&chapter=pages/03&mpage=010&position=3';

      }
      location.href = url;
      console.log(url)

    },
    closeOverlay(){
      this.overlaysStatus = [0,0,0,0];
      document.body.classList.remove('overflow--hidden');
    },
    videoEnded(){
      this.isPlaying = false;
      this.$refs.video.currentTime = 0;
    },
    incrementTrackingPercent(amount){
      let percentage = this.trackingPercentage + amount;
      this.trackingPercentage = percentage;
      if(this.trackingPercentage >= 100){
        lrsService.sendLRS("experienced", '03');
        lrsService.sendLRS("progressed");
      }
    },
    changeChapter(id) {
      this.chapterActive = id;
    },
    openPoint(id){
      console.log(this.tracking, this.trackingPercentage)
      if(this.tracking[id-1] == 0){
        this.incrementTrackingPercent(17);
        this.tracking[id-1] = 1;
      }
      this.pointIndex = id;

    }
  },
  mounted(){

    this.$nextTick(()=>{
      let hasQuery = this.$route.query.position;
      let products = jQuery('.section__experts--04').offset().top;
      if(hasQuery){
        /*if(hasQuery.charAt(0) == "1"){
           this.openOverlay(1);
           this.$refs['overlay_slider-01'].reSlick();
         } else if(hasQuery.charAt(0) == "2"){
           this.openOverlay(2);
         } else if(hasQuery.charAt(0) == "3"){
           this.openOverlay(3);
         }*/
        jQuery('html, body').animate({
          scrollTop: products
        }, 10);
      }
    })


    let _this = this;
    let user = this.$store.getters.user;
    if (typeof user === 'string' || user instanceof String){
      user = JSON.parse(user)
    }
    this.user = user;
    console.log(this.user)
    let trackingStatus = this.$store.getters.moduleStatus;
    for (let i = 0; i < trackingStatus.length; i++) {
      if(trackingStatus[i][0]  == '03'){
        _this.tracking = [1,1,1,1,1,1];
        _this.detailTracking = [1,1,1]
        _this.incrementTrackingPercent(100);
      }
    }
    let detailPages = user.products;
    for (let i = 0; i < detailPages.length; i++) {
      if(detailPages[i].progress == 1 && _this.detailTracking[i] == 0){
        _this.detailTracking[i] = 1;
        _this.incrementTrackingPercent(10)
      }
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>

</style>